module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "phoneVerificationModal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doVerify()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n            Jednorázový ověřovací kód byl odeslán SMS zprávou na číslo "), _c('code', [_vm._v(_vm._s(_vm.phoneNumber))]), _vm._v(".\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Zadejte ověřovací kód:\n          ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.digits),
      expression: "digits"
    }],
    ref: "indigits",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "autocomplete": "one-time-code",
      "maxlength": "4",
      "size": "4",
      "id": "indigits",
      "placeholder": "____",
      "data-1p-ignore": ""
    },
    domProps: {
      "value": (_vm.digits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.digits = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "d-flex w-100"
  }, [_c('div', {
    staticClass: "flex-grow-1 text-left"
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary pl-4 pr-4",
    attrs: {
      "type": "submit",
      "disabled": _vm.digits.length != 4 || _vm.inProgress
    }
  }, [_vm._v("\n                Dokončit ověření\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v("Ověření telefonního čísla")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("\n              Doručení je zpravidla okamžité. V ojedinělých případech může ale trvat až 2-3 minuty.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ef586c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerifyPhoneNumber.vue
// module id = 322
// module chunks = 1 2